module.exports = ".center-block {\n  display: block;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/empty/empty.component.scss
// module id = ./src/app/shared/empty/empty.component.scss
// module chunks = main